import { useMutation, useQuery } from "@tanstack/react-query";
import {
  postSubscription,
  getUserSubscriptions,
  deleteSingleSubscription,
} from "../api/subscription";

interface SubscriptionProps {
  userId?: any;
  subscriptionId?: any;
}

function useSubscriptions({ userId, subscriptionId }: SubscriptionProps) {
  const handlePostSubscription = useMutation((req: any) =>
    postSubscription(req)
  );

  const handleGetUserSubscriptions = useQuery(
    ["userSubscriptions", userId],
    () => getUserSubscriptions(userId),
    {
      enabled: !!userId,
    }
  );

  const handleDeleteSingleSubscription = useMutation((req: any) =>
    deleteSingleSubscription(subscriptionId)
  );

  return {
    handlePostSubscription,
    handleGetUserSubscriptions,
    handleDeleteSingleSubscription,
  };
}

export default useSubscriptions;
